import React from 'react';
import './Appointment.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import { AiFillHome } from "react-icons/ai";
import ContactForm from '../../components/ContactForm/ContactForm';

const Appointment = () => {

    // Link do Google Maps Embed para R. Maj. Kanhangulo 147, Luanda, Angola
    const mapLink = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3977.234566!2d13.2430905!3d-8.805626!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1a51f2461d861b03%3A0x857b519b2fc608ed!2sR.%20Maj.%20Kanhangulo%20147%2C%20Luanda%2C%20Angola!5e0!3m2!1spt-PT!2sao!4v1694149200000!5m2!1spt-PT!2sao';

    return (
        <section className='appointment-section pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <div className="row align-items-center">
                    {/* Mapa */}
                    <div className="col-lg-5 col-md-6">
                        <div className="google-map">
                            <iframe
                                title='map'
                                src={mapLink}
                                width="100%"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>

                            <div className="location-name">
                                <AiFillHome />
                                <p>R. Maj. Kanhangulo 147, Luanda, Angola</p>
                            </div>
                        </div>
                    </div>

                    {/* Formulário de agendamento */}
                    <div className="col-lg-7 col-md-6">
                        <div className="appointment-form-area">
                            <SectionTitle 
                                subTitle="Marcar Consulta"
                                title="Cuidar na Odonto Care é um prazer"
                                description="Nosso compromisso é oferecer atendimento odontológico de qualidade em um ambiente acolhedor e confortável"
                            />

                            <ContactForm />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Appointment;
